export const COLORS = [
  '#ffffff',
  '#000000',
  '#375DE7',
  '#ED6200',
  '#172B4D',
  '#D0021B',
  '#FFAB00',
  '#22A861',
  
  '#fafbfc',
  '#24140F',
  '#361F17',
  '#47291F',
  '#6B3D2E',
  '#BA755E',
  '#C99482',
  '#E0C2B8',

  '#f4f5f7',
  '#960012',
  '#b50016',
  '#d0021b',
  '#dc172f',
  '#ef6e7e',
  '#f6bcc3',
  '#ffd2d8',

  '#ebecf0',
  '#a64500',
  '#d55800',
  '#ed6200',
  '#f08032',
  '#f4ae7e',
  '#fbdfcc',
  '#fff1e8',

  '#dfe1e6',
  '#802000',
  '#B32C00',
  '#E63900',
  '#FF531A',
  '#FF8C66',
  '#FFB299',
  '#FFD9CC',

  '#c1c7d0',
  '#d37300',
  '#ff991f',
  '#ffab00',
  '#ffc400',
  '#ffe380',
  '#fff0b3',
  '#fdf4d0',

  '#b3bac5',
  '#51570F',
  '#798217',
  '#A2AD1F',
  '#CFDD3C',
  '#DAE467',
  '#E4EC93',
  '#EFF4BE',

  '#a5adba',
  '#017a3a',
  '#019044',
  '#22a861',
  '#38c67b',
  '#74dfa7',
  '#aceccb',
  '#d7f9e7',

  '#97a0af',
  '#33570F',
  '#4D8217',
  '#66AD1F',
  '#8CDD3C',
  '#A6E467',
  '#BFEC93',
  '#D9F4BE',

  '#8993a4',
  '#2C8C86',
  '#38B2AB',
  '#54C9C2',
  '#7BD5D0',
  '#9EE0DC',
  '#C5EDEA',
  '#ECF9F8',

  '#7a869a',
  '#0D6D8C',
  '#1191BB',
  '#1AB7EA',
  '#5BCCF0',
  '#8ADAF4',
  '#D0F0FB',
  '#E8F8FD',

  '#6b778c',
  '#21388b',
  '#2c4ab8',
  '#375de7',
  '#5e7ceb',
  '#8fa7ff',
  '#d7defa',
  '#e7ecfc',

  '#5e6c84',
  '#125AA1',
  '#1774CF',
  '#308DE8',
  '#5EA7ED',
  '#8CC0F2',
  '#BAD9F7',
  '#D1E6FA',

  '#505f79',
  '#291A7F',
  '#3622AA',
  '#4229CC',
  '#8F80E5',
  '#B4AAEE',
  '#DAD5F6',
  '#ECEAFB',

  '#42526e',
  '#33344A',
  '#464775',
  '#6264A7',
  '#8B8CC7',
  '#BDBDE6',
  '#E2E2F6',
  '#F4F4FC',

  '#344563',
  '#750D8C',
  '#9C11BB',
  '#AE29CC',
  '#D55BF0',
  '#E18AF4',
  '#F3D0FB',
  '#F9E8FD',

  '#253858',
  '#8A0F4D',
  '#B81466',
  '#E61980',
  '#EB4799',
  '#F075B3',
  '#F5A3CC',
  '#FAD1E6',

  '#172b4d',
  '#091d42',
  '#3b5998',
  '#1da1f2',
  '#ff0000',
  '#007bb5',
  '#4285f4',
  '#1ab7ea',
];

export const Presets = {
  'Got It PRO': {
    variables: {
      "--colorPrimaryLighter": "#e7ecfc",
      "--colorPrimaryLight": "#d7defa",
      "--colorPrimary": "#375de7",
      "--colorFocusPrimary": "#375de733",
      "--colorPrimaryDark": "#2c4ab8",
      "--colorPrimaryDarker": "#21388b",
      "--colorAccentLighter": "#fff1e8",
      "--colorAccentLight": "#fbdfcc",
      "--colorAccent": "#ed6200",
      "--colorFocusAccent": "#ed620033",
      "--colorAccentDark": "#d55800",
      "--colorAccentDarker": "#a64500",
      "--colorNegativeLighter": "#ffd2d8",
      "--colorNegativeLight": "#f6bcc3",
      "--colorNegative": "#d0021b",
      "--colorFocusNegative": "#d0021b33",
      "--colorNegativeDark": "#b50016",
      "--colorNegativeDarker": "#960012",
      "--colorWarningLighter": "#fdf4d0",
      "--colorWarningLight": "#fff0b3",
      "--colorWarning100": "#ffe380",
      "--colorWarning": "#ffc400",
      "--colorFocusWarning": "#ffc40033",
      "--colorWarning300": "#ffab00",
      "--colorWarningDark": "#ff991f",
      "--colorPositiveLighter": "#d7f9e7",
      "--colorPositiveLight": "#aceccb",
      "--colorPositive": "#22a861",
      "--colorFocusPositive": "#22a86133",
      "--colorPositiveDark": "#019044",
      "--colorPositiveDarker": "#017a3a",
      "--colorInformationLighter": "#e7ecfc",
      "--colorInformationLight": "#d7defa",
      "--colorInformation": "#375de7",
      "--colorFocusInformation": "#375de733",
      "--colorInformationDark": "#2c4ab8",
      "--colorInformationDarker": "#21388b",
      "--fontFamily": "Roboto,'Helvetica Neue',Helvetica,Arial,sans-serif",
      "--fontRegular": "400",
      "--fontMedium": "500",
      "--fontBold": "700",
      "--radiusSmall": "2px",
      "--radiusMedium": "4px",
      "--radiusLarge": "8px",
      "--radiusExtraLarge": "16px",
    },
  },
  'Got It STUDY': {
    variables: {
      "--colorPrimaryLighter": "#ECEAFB",
      "--colorPrimaryLight": "#DAD5F6",
      "--colorPrimary": "#4229CC",
      "--colorFocusPrimary": "#4229CC33",
      "--colorPrimaryDark": "#3622AA",
      "--colorPrimaryDarker": "#291A7F",
      "--colorAccentLighter": "#f4f4fc",
      "--colorAccentLight": "#e2e2f6",
      "--colorAccent": "#54C9C2",
      "--colorFocusAccent": "#54C9C233",
      "--colorAccentDark": "#38B2AB",
      "--colorAccentDarker": "#2C8C86",
    },
  },
  'STEAM for Vietnam': {
    variables: {
      "--colorPrimaryLighter": "#fdf4d0",
      "--colorPrimaryLight": "#fff0b3",
      "--colorPrimary": "#ffab00",
      "--colorFocusPrimary": "#ffab0033",
      "--colorPrimaryDark": "#ff991f",
      "--colorPrimaryDarker": "#d37300",
      "--colorAccentLighter": "#c5edea",
      "--colorAccentLight": "#ecf9f8",
      "--colorAccent": "#54c9c2",
      "--colorFocusAccent": "#54c9c233",
      "--colorAccentDark": "#38b2ab",
      "--colorAccentDarker": "#2c8c86",
      "--fontFamily": "Quicksand, 'Helvetica Neue', Helvetica, Arial, sans-serif",
      "--fontRegular": "500",
      "--fontMedium": "600",
      "--fontBold": "700",
    },
  },
};

export const VARIABLES = {
  "--colorPrimaryLighter": "#e7ecfc",
  "--colorPrimaryLight": "#d7defa",
  "--colorPrimary": "#375de7",
  "--colorFocusPrimary": "#375de733",
  "--colorPrimaryDark": "#2c4ab8",
  "--colorPrimaryDarker": "#21388b",
  "--colorAccentLighter": "#fff1e8",
  "--colorAccentLight": "#fbdfcc",
  "--colorAccent": "#ed6200",
  "--colorFocusAccent": "#ed620033",
  "--colorAccentDark": "#d55800",
  "--colorAccentDarker": "#a64500",
  "--colorNegativeLighter": "#ffd2d8",
  "--colorNegativeLight": "#f6bcc3",
  "--colorNegative": "#d0021b",
  "--colorFocusNegative": "#d0021b33",
  "--colorNegativeDark": "#b50016",
  "--colorNegativeDarker": "#960012",
  "--colorWarningLighter": "#fdf4d0",
  "--colorWarningLight": "#fff0b3",
  "--colorWarning100": "#ffe380",
  "--colorWarning": "#ffc400",
  "--colorFocusWarning": "#ffc40033",
  "--colorWarning300": "#ffab00",
  "--colorWarningDark": "#ff991f",
  "--colorPositiveLighter": "#d7f9e7",
  "--colorPositiveLight": "#aceccb",
  "--colorPositive": "#22a861",
  "--colorFocusPositive": "#22a86133",
  "--colorPositiveDark": "#019044",
  "--colorPositiveDarker": "#017a3a",
  "--colorInformationLighter": "#e7ecfc",
  "--colorInformationLight": "#d7defa",
  "--colorInformation": "#375de7",
  "--colorFocusInformation": "#375de733",
  "--colorInformationDark": "#2c4ab8",
  "--colorInformationDarker": "#21388b",
  "--fontFamily": "Roboto,'Helvetica Neue',Helvetica,Arial,sans-serif",
  "--fontRegular": "400",
  "--fontMedium": "500",
  "--fontBold": "700",
  "--radiusSmall": "2px",
  "--radiusMedium": "4px",
  "--radiusLarge": "8px",
  "--radiusExtraLarge": "16px",
};